// Scroll to Anchor if #hash is set
function scrollToAnchor($animation=500) {
    if (window.location.hash) {
        var $offset = $('.bodyWrapper .headerWrapper').outerHeight() - 3;
        var $scrollTo = $(window.location.hash);
        if ($scrollTo.length) {
            $('html, body').animate({
                scrollTop: $($scrollTo).offset().top - $offset
            }, $animation);
        }
    }
}

// Listen for page preloading event.
document.addEventListener('preloaded', function (event) {
    scrollToAnchor($animation=0);
}, false);

$(window).on("load", function () {
    scrollToAnchor($animation=0);
});

// Listen to Anchor Clicks
if ("onhashchange" in window) window.onhashchange = function () {
    scrollToAnchor();
};
